import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us! We will get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <section className="contactus-section-home" id="contactus-section">
      <div className="contactus-container-home">
        <h2 className="contactus-title-home" data-aos="fade-up">
          Contact <span>Us</span>
        </h2>

        <div className="contactus-grid-home">
          {/* Contact Info */}
          <div className="contactus-info-home" data-aos="fade-up" data-aos-delay="100">
            <div className="contactus-info-item-home">
              <FaMapMarkerAlt className="contactus-icon-home" />
              <p>123 NGO Street, Kolkata, West Bengal, India</p>
            </div>
            <div className="contactus-info-item-home">
              <FaPhoneAlt className="contactus-icon-home" />
              <p>+91 9876543210</p>
            </div>
            <div className="contactus-info-item-home">
              <FaEnvelope className="contactus-icon-home" />
              <p>info@dewt.org</p>
            </div>
          </div>

          {/* Contact Form */}
          <form
            className="contactus-form-home"
            onSubmit={handleSubmit}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
